<script setup lang="ts">
import { EventTypeEnum } from "@/models";
import { useDataLayerStore, useExternalLinksStore } from "@/stores";

interface Props {
    title?: string;
}
const { title = "Key information for new customers" } = defineProps<Props>();

const dataLayer = useDataLayerStore();
const externalLinks = useExternalLinksStore();
</script>

<template>
    <div class="key-information">
        <b>{{ title }}</b>

        <div class="download-box">
            <div
                v-for="link in externalLinks.keyInformationLinks"
                :key="link.keyName"
                class="inner"
            >
                <a
                    target="_blank"
                    :href="link.linkUrl"
                    @click="
                        dataLayer.triggerEvent(
                            EventTypeEnum.PageInteraction,
                            `download|${link.keyName}`
                        )
                    "
                >
                    {{ link.displayName }}
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.download-box {
    padding: 0;
    border: none;

    .inner a {
        padding: 8px 0 10px 30px;
        color: var(--off-black);
        display: block;
        text-decoration: underline;
        background: url("@/assets/img/policy-doc-icon.svg") no-repeat 5px center;
        background-size: 22px;
        font-size: 0.9rem;
    }
}
</style>
